import type { CommentDetailsNested } from "@/server/api/routers/comment";

export const flattenComments = (commentsToFlatten: CommentDetailsNested[]) => {
  const allComments: typeof commentsToFlatten = [];

  const processComment = (comment: (typeof commentsToFlatten)[number]) => {
    // Add the current comment to the flat list
    allComments.push(comment);

    // If the comment has children, process each child comment recursively
    if (comment.children.length > 0) {
      comment.children.forEach(processComment);
    }
  };

  // Start processing each top-level comment
  commentsToFlatten.forEach(processComment);

  return allComments;
};
